import React from "react";
import { useLmcUserView } from "../../../../contexts/AuthContext";
import { Navigate, useParams } from "react-router-dom";

const LmcPrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const params = useParams();
  const { state } = useLmcUserView();

  if (!state.auth.isAuthenticated)
    return <Navigate to={`/loyalty-program/${params.processId}`} />;

  return <>{children}</>;
};

export default LmcPrivateRoute;
